import React from 'react';
import { twMerge } from 'tailwind-merge';

type StrategyMarkerCircleProps = {
  isHovered?: boolean;
  className?: string;
  children: React.ReactNode;
  colorClass?: string;
  hoverColorClass?: string;
};

const StrategyMarkerCircle: React.FC<StrategyMarkerCircleProps> = ({
  isHovered = false,
  className = '',
  children,
  colorClass = 'bg-indigo-600',
  hoverColorClass = 'bg-sky-600',
}) => {
  return (
    <div
      className={twMerge(`
        w-8 h-8 flex items-center justify-center rounded-full
        ${colorClass} border-4 border-white shadow-lg
        transition-all duration-200 ease-out cursor-pointer
        ${isHovered ? `scale-110 ${hoverColorClass}` : 'hover:scale-105'}
        ${className}
    `)}
    >
      {children}
    </div>
  );
};

export default StrategyMarkerCircle;
